import React from 'react'
import { Typography, Box } from '@mui/material'

const ReportsPage: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Reports & Analytics
      </Typography>
      <Typography variant="body1">
        This page will display comprehensive reports and analytics dashboards.
      </Typography>
    </Box>
  )
}

export default ReportsPage
